<template>
  <div class="admin-data" v-title data-title="数据查询">
    <header>
      <!-- 个人信息 -->
      <div class="personal-information">
        <div class="centre">
          <img src="../../assets/images/17.png" alt="">
          <div class="name">
            运营
          </div>
        </div>
      </div>
    </header>
    <section>
      <!-- 总计 -->
      <div class="statistics">
        <p>
          全部
        </p>
        <p @click="show = true">
          筛选
        </p>
        <p>
          {{time}}
        </p>
        <p>
          共计￥{{data_list.same_month_amount}}
        </p>
      </div>
      <!-- 订单详情 -->
      <div class="order-msg">
        <p class="title">
          <span></span>
          订单详情
        </p>
        <div class="content" v-for="(item,index) in data_list.list" :key="index">
          <div class="title1">
            <p>
              {{item.name}}
            </p>
            <p>
              {{item.create_time}}
            </p>
            <p>
              ￥{{item.total_price}}
            </p>
          </div>
          <!-- 奖励 分成 -->
          <div class="award">
            <div class="award-content">
              <p>
                1%
                <span>
                  ￥{{item.user_amount}}
                </span>
              </p>
              <p>
                消费者奖励
              </p>
            </div>
            <div class="award-content">
              <p>
                1%
                <span>
                  ￥{{item.owner_leader_amount}}
                </span>
              </p>
              <p>
                推荐商家分成
              </p>
            </div>
            <div class="award-content">
              <p>
                1%
                <span>
                  ￥{{item.first_leader_amount}}
                </span>
              </p>
              <p>
                推荐用户分成:
              </p>
            </div>
          </div>
          <div class="income">
            <p>
              税交易:{{item.taxation}}% ￥{{item.taxes}}
            </p>
            <p>
              商家收入:{{item.commission}}% ￥{{item.amount}}
            </p>
            <p>
              平台收入:{{item.terrace}}% ￥{{item.platform_income}}
            </p>
          </div>
        </div>
        <!-- <p class="paging" @click="paging_btn">
          点击加载更多
        </p> -->
        <van-pagination v-model="currentPage" :page-count="all_page" mode="simple" @change="next_page"/>
      </div>
    </section>
    <!-- 时间选择 -->
    <van-popup v-model="show" position="bottom" :style="{ height: '40%' }" >
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @cancel="show = false"
        @confirm="confirm_btn"
      />
    </van-popup>
  </div>
</template>

<script>

import Vue from 'vue';
import { DatetimePicker, Popup, Pagination } from 'vant';

Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(Pagination);

export default {
  data(){
    return{
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      show: false,
      time: '本月',
      search_time: '',
      uid: '',
      data_list: [], // 数据列表
      currentPage: 1, //当前页数
      all_page: '',
    }
  },
  created(){
    this.uid = JSON.parse(localStorage.getItem("uid"));
    this.$axios.post(this.domain.url+"/api/user/index/operational_data",{
      uid : this.uid,
      // search_time : this.search_time
    }).then((res) => {
      // console.log(res.data.data)
      this.data_list = res.data.data
      this.currentPage = res.data.data.now_page
      this.all_page = res.data.data.all_page
    })
  },
  methods:{
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    // 时间选择确定按钮
    confirm_btn(){
      this.time = this.currentDate.getFullYear() + '-' + (this.currentDate.getMonth() + 1)
      this.search_time = this.currentDate.getFullYear() + '-' + (this.currentDate.getMonth() + 1)
      // let uid = JSON.parse(localStorage.getItem("uid"));
      // this.$axios.post(this.domain.url+"/api/order/index/optionsList",{
      //   uid : uid,
      //   type : 2,
      //   search_time : this.search_time
      // }).then((res) => {
      //   // console.log(res)
      //   this.share_option_msg = res.data.data
      // })
      this.show = false
      this.$axios.post(this.domain.url+"/api/user/index/operational_data",{
        uid : this.uid,
        search_time : this.search_time
      }).then((res) => {
        // console.log(res)
        this.data_list = res.data.data
      })
    },
    // 分页
    next_page(){
      this.$axios.post(this.domain.url+"/api/user/index/operational_data",{
        uid : this.uid,
        page : this.currentPage
        // search_time : this.search_time
      }).then((res) => {
        // console.log(res.data.data)
        this.data_list = res.data.data
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .admin-data{
    width: 7.5rem;
    background: #f4f4f4;
    header{
      // 个人信息
      .personal-information{
        width: 100%;
        height: 1.95rem;
        background-image: url('../../assets/images/data-centre-img/1.png');
        overflow: hidden;
        .centre{
          width: 7.1rem;
          height: 1rem;
          margin: 0 auto;
          display: flex;
          align-items: center;
          margin-top: .23rem;
          img{
            width: 1rem;
            height: 1rem;
          }
          .name{
            font-size: 0.3rem;
            font-family: PingFang SC;
            font-weight: bold;
            color: #212121;
            margin-left: .2rem;
          }
        }
      }
    }
    section{
      // 总计
      .statistics{
        width: 7.1rem;
        height: 1.2rem;
        background: #fff;
        border-radius: .1rem;
        margin: 0 auto;
        margin-top: -.46rem;
        line-height: 1.2rem;
        // display: flex;
        // align-items: center;
        p{
          &:first-child{
            margin-left: .36rem;
            font-size: 0.3rem;
            font-family: PingFang SC;
            font-weight: bold;
            color: #212121;
            float: left;
          }
          &:nth-child(2){
            width: .9rem;
            height: .5rem;
            background-image: url('../../assets/images/data-centre-img/2.png');
            background-size: .9rem .5rem;
            margin-left: .21rem;
            line-height: .5rem;
            text-align: center;
            font-size: 0.24rem;
            font-family: PingFang SC;
            font-weight: 400;
            color: #A1A1A1;
            float: left;
            margin-top: .37rem;
          }
          &:nth-child(3){
            // margin-right: 43%;
            margin-left: .11rem;
            font-size: 0.24rem;
            font-family: PingFang SC;
            font-weight: 400;
            color: #A1A1A1;
            float: left;
          }
          &:nth-child(4){
            font-size: 0.22rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: #A1A1A1;
            float: right;
            margin-right: .2rem;
          }
        }
      }
      // 订单详情
      .order-msg{
        .title{
          height: 1rem;
          margin-left: .2rem;
          font-size: 0.3rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #212121;
          display: flex;
          align-items: center;
          span{
            display: inline-block;
            width: .08rem;
            height: .4rem;
            background: #fec900;
            margin-right: .12rem;
            border-radius: .1rem;
          }
        }
        // 订单详情列表
        .content{
          width: 7.1rem;
          height: 3.46rem;
          background: #fff;
          margin: 0 auto;
          border-radius: .1rem;
          margin-bottom: .2rem;
          .title1{
            width: 100%;
            height: 1.18rem;
            border-bottom: .01rem dashed #999999;
            // display: flex;
            // align-items: center;
            line-height: 1.18rem;
            p{
              &:first-child{
                float: left;
                font-size: 0.24rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #212121;
                margin-left: .21rem;
              }
              &:nth-child(2){
                float: left;
                font-size: 0.24rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #ABABAB;
                margin-left: .12rem;
              }
              &:nth-child(3){
                float: right;
                font-size: 0.36rem;
                font-family: PingFang SC;
                font-weight: bold;
                color: #FF6600;
                margin-right: .2rem;
              }
            }
          }
          // 奖励
          .award{
            width: 100%;
            height: 1.4rem;
            border-bottom: .01rem dashed #f4f4f4;
            display: flex;
            align-items: center;
            .award-content{
              width: 33%;
              text-align: center;
              p{
                &:first-child{
                  font-size: 0.36rem;
                  font-family: PingFang SC;
                  font-weight: bold;
                  color: #212121;
                  span{
                    font-size: 0.24rem;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #212121;
                  }
                }
                &:last-child{
                  font-size: 0.24rem;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #919191;
                }
              }
            }
          }
          .income{
            height: .86rem;
            display: flex;
            align-items: center;
            p{
              width: 33%;
              text-align: center;
              font-size: 0.24rem;
              font-family: PingFang SC;
              font-weight: 500;
              color: #919191;
            }
          }
        }
      }
      .paging{
        text-align: center;
        line-height: .5rem;
      }
    }
  }
</style>